module.exports = __webpack_public_path__ + "img/develop4-2@2.b0c98cfa.png";